import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'
import { cn } from 'cn'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

export const CourseContentSkeleton = ({ className }: { className?: string }): ReactNode => (
  <Skeleton
    className={cn(
      'h-[80vh] w-full',
      className,
      addPublicCustomClassNamePrefix('course__content-skeleton'),
    )}
  />
)
